export class Product {
  crmId: string;
  name: string;
  tag: string;

  public static isProduct(obj: any): obj is Product {
    return (<Product>obj).crmId !== undefined &&
      (<Product>obj).name !== undefined &&
      (<Product>obj).tag !== undefined;
  }
}
